import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import Close from 'images/close.svg'

const scrollStyles = `
  .detailed-error-modal-scrollable-list::-webkit-scrollbar {
    width: 5px;
  }
  .detailed-error-modal-scrollable-list::-webkit-scrollbar-thumb {
    border-radius: 20px;
    border: 3px solid #d3d2d6;
  }
`;

if (typeof document !== 'undefined' && !document.getElementById('detailed-error-modal-scroll-styles')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'detailed-error-modal-scroll-styles';
  styleElement.textContent = scrollStyles;
  document.head.appendChild(styleElement);
}

const DetailedErrorModal = ({
  text,
  onClose,
  title,
  above,
  details, // eslint-disable-line no-unused-vars
  reasonText,
  reasonLabel,
  scrollableList,
  footerText,
  buttonText,
  translate
}) => (
  <Modal size='sm' className={`mission-block-container-modal ${above ? 'modal-above' : ''}`}>
    <div className='detailed-error-modal-content'>
      <img src={Close} alt="erro" />
      <p className="detailed-error-modal-title">
        {title}
      </p>
      <p className="detailed-error-modal-text">
        {text}
      </p>
      {reasonText && (
        <div className="detailed-error-modal-reason-container">
          {reasonLabel && <span className="detailed-error-modal-reason-label">{reasonLabel}</span>}
          <span className="detailed-error-modal-reason-text" dangerouslySetInnerHTML={{ __html: reasonText }}></span>
        </div>
      )}
      {scrollableList && Array.isArray(scrollableList) && scrollableList.length > 0 && (
        <div className="detailed-error-modal-scrollable-list">
          {scrollableList.map((item, index) => (
            <div key={index} className="detailed-error-modal-list-item">
              {item}
            </div>
          ))}
        </div>
      )}
      {footerText && (
        <div className="detailed-error-modal-footer-text">
          {footerText}
        </div>
      )}
      <div className="detailed-error-modal-footer">
        <button
          className="detailed-error-modal-button"
          onClick={onClose}
        >
          {buttonText || (translate && translate('close_button_label'))}
        </button>
      </div>
    </div>
  </Modal>
);

DetailedErrorModal.propTypes = {
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  above: PropTypes.bool,
  details: PropTypes.string,
  reasonText: PropTypes.string,
  reasonLabel: PropTypes.string,
  scrollableList: PropTypes.array,
  footerText: PropTypes.string,
  buttonText: PropTypes.string,
  translate: PropTypes.func,
}

export default DetailedErrorModal
